import React from 'react';
import { roughSanitizeHtml } from 'libs/end-to-end/src/html';

export const TextWithNewlines = (props: { text: string }) => {
  const { text } = props;

  if (text === ' ') {
    return <>&nbsp;</>;
  }

  // convert the newlines to <br /> and set the inner HTML
  const textWithLinebreaks = text
    .replace(/(?:\r\n|\r|\n)/g, '<br />')
    .replace(/ {2,}/g, (match) => '&nbsp;'.repeat(match.length));

  if (text === textWithLinebreaks) {
    // no newlines, so just return the text
    return text;
  }

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: roughSanitizeHtml(textWithLinebreaks),
      }}
    />
  );
};
